import { useEffect, useState, useCallback } from 'react'
import { funnelApi } from '../api'
import type { FunnelVersion } from '../types'

/** Version history hook — uses changelog API filtered by funnel ID */
export function useFunnelVersions(funnelId: string | undefined) {
  const [versions, setVersions] = useState<FunnelVersion[]>([])
  const [loading, setLoading] = useState(false)

  const fetchVersions = useCallback(async () => {
    if (!funnelId) return
    setLoading(true)
    try {
      const response = await funnelApi.listVersions(funnelId)
      setVersions(response.data)
    } catch {
      setVersions([])
    } finally {
      setLoading(false)
    }
  }, [funnelId])

  useEffect(() => {
    fetchVersions()
  }, [fetchVersions])

  return { versions, loading, refetch: fetchVersions }
}
